<script>
import { Tile as TileLayer, Vector as VectorLayer } from "ol/layer";
import { Vector as VectorSource } from "ol/source";
import { getVectorContext } from "ol/render";
import GeoJSON from "ol/format/GeoJSON";
import parseStyle from "../ol-map/utils/style";

let olMap = null;

export default {
  name: "ol-layer-tile",

  inject: ["getMap"],

  render() {
    return this.$slots.default;
  },

  provide() {
    return {
      getLayer: this.getLayer,
    };
  },

  props: {
    // 图层名称
    name: {
      type: String,
      default: "",
    },

    // 图层类型
    type: {
      type: String,
      default: "",
    },

    // 是否可见
    visible: {
      type: Boolean,
      default: true,
    },

    // 透明度（0~1）
    opacity: {
      type: Number,
      default: 1,
    },

    // 层级
    zIndex: {
      type: Number,
      default: undefined,
    },

    // 预加载（Infinity / 0）
    preload: {
      type: Number,
      default: 0,
    },

    // 裁切边界
    clip: {
      type: String,
      default: "",
    },
  },

  watch: {
    visible(visible) {
      this.tileLayer.setVisible(visible);
    },

    zIndex(zIndex) {
      this.tileLayer.setZIndex(zIndex);
    },

    clip(newVal) {
      if (newVal) {
        const vectorSource = this.clipLayer.getSource();
        vectorSource.clear();
        const features = new GeoJSON().readFeatures(newVal);
        vectorSource.addFeatures(features);
      }
    },
  },

  data() {
    return {
      tileLayer: null,
      clipLayer: null,
    };
  },

  created() {
    this.tileLayer = new TileLayer({
      className: "stamen",
      name: this.name,
      type: this.type,
      visible: this.visible,
      zIndex: this.zIndex,
      opacity: this.opacity,
      preload: this.preload,
    });

    this.clipLayer = new VectorLayer({
      name: "clip",
      source: new VectorSource({
        features: this.clip ? new GeoJSON().readFeatures(this.clip) : [],
      }),
      style: null,
    });

    if (this.clip) {
      this.setLayerFilterClip(
        this.tileLayer,
        new GeoJSON().readFeatures(this.clip)[0]
      );
    }
    this.getMap((map) => {
      olMap = map;
      if (this.clipLayer !== null) {
        map.addLayer(this.clipLayer);
      }
      map.addLayer(this.tileLayer);
    });
  },

  methods: {
    // 获取组件实例
    getLayer(cb) {
      cb(this.tileLayer);
    },
    setLayerFilterClip(layer, feature) {
      layer.on("prerender", (event) => {
        let vectorContext = getVectorContext(event);
        event.context.globalCompositeOperation = "source-over";
        let ctx = event.context;
        ctx.save();
        vectorContext.drawFeature(
          feature,
          parseStyle({ fill: { color: "transparent" } })
        );
        ctx.clip();
      });
      layer.on("postrender", (event) => {
        let ctx = event.context;
        ctx.restore();
      });
      layer.setExtent(feature.getGeometry().getExtent());
    },

    addfeatureHandle() {
      // this.tileLayer.setExtent(this.clipLayer.getSource().getExtent());
    },

    postrenderHandle(e) {
      const vectorContext = getVectorContext(e);
      e.context.globalCompositeOperation = "destination-in";
      this.clipLayer.getSource().forEachFeature((feature) => {
        vectorContext.drawFeature(
          feature,
          parseStyle({ fill: { color: "transparent" } })
        );
      });
      e.context.globalCompositeOperation = "source-over";
    },
  },

  beforeDestroy() {
    if (this.clipLayer) {
      this.clipLayer.getSource().un("addfeature", this.addfeatureHandle);
    }
    this.tileLayer.un("postrender", this.postrenderHandle);
    olMap.removeLayer(this.clipLayer);
    olMap.removeLayer(this.tileLayer);
    this.tileLayer = null;
    this.clipLayer = null;
  },
};
</script>
